<template>
	<div>
  	<content-header ></content-header>
		<div class="content-wrapper">
			<!-- 冰柜基本信息 -->
		  <el-card class="card">
				 <el-row >
					<el-col class="col-title"> 冰柜基本信息</el-col>
				 </el-row>

				 <el-row>
					<el-col :span="12">
							<el-row class="row" v-if="freezerInfo.coolerInfo">
								<BaseCell :value="freezerInfo.coolerInfo.coolerName" label="冰柜名称" />
							</el-row>
								<el-row class="row" v-if="freezerInfo.coolerInfo">
							<BaseCell :value="freezerInfo.coolerInfo.coolerAssetCode" label="资产编码" />
							</el-row>
								<el-row class="row" v-if="freezerInfo.coolerInfo">
							<BaseCell :value="stateName" label="冰柜状态" />
							</el-row>
					</el-col>
					<el-col :span="12">
						<el-row>
							<el-col :span="6">冰柜图片</el-col>
							<el-col :span="18">
								<div v-if="freezerInfo.coolerInfo&&freezerInfo.coolerInfo.coolerImages.length">
											<div
												v-for="img in freezerInfo.coolerInfo.coolerImages"
												:key="img.coolerItemImageId"
											>
												<el-image 
													style="width: 100px; height: 100px"
													:src="img.coolerItemImageUri" 
													:preview-src-list="srcList">
												</el-image>
											<!-- <img style="width:80px;height:80px" :src="getImg(img.coolerItemImageUri)" /> -->
										</div>
									</div>
								<div v-else>暂无</div>
							</el-col>
						</el-row>
					</el-col>
				 </el-row>
			</el-card>
			<!--冰柜押金信息 -->
			 <el-card class="card" >
				 <el-row>
					<!--冰柜押金信息  -->
					<el-col class="col-title">冰柜押金信息</el-col>
				</el-row>
				<el-row class="row">押金支付信息</el-row >
				<el-row class="row">
		      <el-table
					:data="freezerInfo.coolerPledgePayInfo"
					border
					style="width: 100%;">
					<el-table-column
						align="center"
						prop="pledgeAmount"
						label="押金支付金额 (元)"
						>
					</el-table-column>
					<el-table-column
						align="center"
						prop="time"
						label="押金支付时间"
						>
					</el-table-column>
					<el-table-column
						prop="paidContactPerson"
							align="center"
						label="支付人姓名">
					</el-table-column>
					<el-table-column
						prop="paidContactPhone"
						align="center"
						label="支付账号">
					</el-table-column>
				</el-table>
				</el-row >
				<!--押金返回信息  -->
				<el-row class="row">押金返回信息</el-row >
				<el-row class="row">
		      <el-table
					:data="freezerInfo.coolerPledgeReturnInfo"
					border
					style="width: 100%">
					<el-table-column
						align="center"
						prop="pledgeAmount"
						label="押金返还金额 (元)"
						>
					</el-table-column>
					<el-table-column
						align="center"
						prop="time"
						label="押金返还时间"
						>
					</el-table-column>
					<el-table-column
						prop="paidContactPerson"
							align="center"
						label="返还人姓名">
					</el-table-column>
					<el-table-column
						prop="paidContactPhone"
							align="center"
						label="返还账号">
					</el-table-column>
				</el-table>
				</el-row >
			</el-card>
			<!-- 冰柜生命周期 -->
			<el-card class="card" >
				 <el-row >
					<el-col class="col-title">冰柜生命周期</el-col>
				 </el-row>
				  <el-row style="margin-left:28%">
					<div v-for="(item,index) in lifecycle " :key="index" class="step" >
          <el-row>
            <el-col :span="4">
              <div class="step-left">
                <div class="step-left_name">{{ item.execTypeSubName }}</div>
                <div>{{ item.approvalTime }}</div>
              </div>
            </el-col>
            <el-col :span="2">
              <div class="step-middle">
                <div class="step-middle_number">{{ lifecycle.length-index }}</div>
                <div class="step-middle_line" />
              </div>
            </el-col>
            <el-col :span="18">
              <div class="step-right">
                  <div v-if="item.execTypeSub!=='114'"><div>申请单号</div> <div>{{ item.applyNumber }}</div></div>
                  <div v-if="item.execTypeSubName==='冰柜回库'&&item.execTypeSub!=='114'"><div>回库经销商</div> <div>{{ item.wholesalerName }}</div></div>
                  <div v-if="item.warehouseName"><div>仓库名称 </div><div>{{ item.warehouseName }}</div></div>
                  <div v-if="item.execTypeSubName==='冰柜回库'"><div>仓库地址</div> <div>{{ item.warehouseAddress }}</div></div>
                  <div v-if="item.execTypeSubName!=='冰柜回库'&&item.execTypeSub!=='114'"><div>{{ item.execTypeSubName === '冰柜到店'? '申请店名': '投放店名' }} </div><div>{{ item.applyPocName }}</div></div>
                  <div v-if="item.execTypeSubName!=='冰柜回库'&&item.execTypeSub!=='114'"><div>{{ item.execTypeSubName === '冰柜到店'? '申请投放地址': '投放地址' }}</div> <div>{{ item.applyPocAddress }}</div></div>
                  <div v-if="item.applyUserName"><div>申请人</div> <div>{{ item.applyUserName }}</div></div>
                  <div v-if="item.execTypeSubName!=='冰柜回库'&&item.execTypeSub!=='114'"><div>POCID</div> <div>{{ item.pocCode }}</div></div>
                  <div v-if="item.execTypeSubName!=='冰柜回库'&&item.execTypeSub!=='114'"><div>WCCSID</div> <div>{{ item.wccsId }}</div></div>
              </div>
            </el-col>
          </el-row>
        </div>
					</el-row>
			</el-card>

			
		</div>
	</div>
</template>

<script>
import ContentHeader from '@/components/content-header';
import BaseCell from '@/components/base-cell'
import tradeApi  from '@/api/trade'
import { commonUtils } from '@/utils/common'
import {parseTime,toFormatNumber}from '@/filters'
export default {
	name:'freezer-details',
	components: {
			ContentHeader,
			BaseCell

		},
		data() {
			return {
				freezerInfo:'',//冰柜的信息
				lifecycle:[],//冰柜的生命周期
				srcList:[],//图片预览
			}
		},
	 created(){
   this.getInfo()
	 },
	 computed:{
		stateName(){
			if(this.freezerInfo.coolerInfo.execType==='21'||
			   this.freezerInfo.coolerInfo.execType==='22'||
				 this.freezerInfo.coolerInfo.execType==='23')return this.freezerInfo.coolerInfo.execTypeName
			if(this.freezerInfo.coolerInfo.coolerAssetStatus==='5'||
			   this.freezerInfo.coolerInfo.coolerAssetStatus==='6')return '正常投放'
		    return	this.freezerInfo.coolerInfo.coolerAssetStatusName
		}
	 },
	 methods:{
		// 获取冰柜信息
	 async	getInfo(){
		const {data:{resultData}}=await  tradeApi.getFreezerInfo(this.$route.query.id)
		this.freezerInfo=resultData
		this.freezerInfo.coolerPledgePayInfo.forEach(item=>item.time=parseTime(item.time))//处理时间
		this.freezerInfo.coolerPledgeReturnInfo.forEach(item=>item.time=parseTime(item.time))//处理时间
		this.freezerInfo.coolerPledgePayInfo.forEach(item=>item.pledgeAmount=toFormatNumber(item.pledgeAmount,2))//处理金钱
		this.freezerInfo.coolerPledgeReturnInfo.forEach(item=>item.pledgeAmount=toFormatNumber(item.pledgeAmount,2))//处理金钱
		this.freezerInfo.coolerInfo.coolerImages.forEach(item=>item.coolerItemImageUri=commonUtils.getImageUrl(item.coolerItemImageUri))//处理图片地址
		this.freezerInfo.coolerInfo.coolerImages.forEach(item=>this.srcList.push(item.coolerItemImageUri))//图片预览数据
		this.lifecycle=this.freezerInfo.coolerLifeCycleInfo//冰柜生命周期
		}
	 }
}
</script>

<style lang="scss" scoped>
::v-deep .el-table th.el-table__cell>.cell {
	color:#000
}
 .step-left{
    text-align: end;
    &_name{
      font-weight: 700;
      font-size: 18px;
      color: #000;
      margin-bottom: 10px;
    }
  }
  .step-middle{
    display: flex;
    flex-direction: column;
    align-items: center;
    &_number{
      width: 20px;
      height: 20px;
      border-radius: 50%;
      background-color: #ce1332;
      text-align: center;
      line-height: 20px;
      color: #fff;
    }
    &_line{
      height: 220px;
      width: 1px;
      background-color: #ce1332;
      margin: 5px 0;
    }
  }
  .step:last-child{
   .step-middle{
     &_line{
       height: 0;
     }
   }
  }
  .step-right{
    &>div{
      margin-bottom: 15px;
      font-size: 16px;
      display: flex;
      align-items: center;
      div:nth-child(1){
        min-width: 130px;
      }
    }
  }
.content-wrapper {
  min-height: calc(100vh - 320px) !important;
		margin-top: -30px;
	.row{
		margin-bottom: 15px;
		margin-left: 10px;
	}
	.card{
		margin-bottom: 20px;
	}
	.col-title{
		margin-left: 10px;
		margin-bottom: 15px;

		font-weight: 700;
	}
	.col-title:before {
    content: "";
    display: inline-block;
    height: 14px;
    width: 4px;
    position: absolute;
    left: 0;
    border-radius: 2px;
    background-color: #C8102D;
    }
}
</style>